<template>
  <v-container fluid class="px-0 cst-payments-config">
		<div v-m2-span>
			<div class="my-4 mx-2" v-if="showHeader">
				<div class="d-flex align-center">
					<div class="flex-grow-1 mr-2" style="border-bottom: 1px solid #ccc;"></div>
					<span class="mx-2 font-weight-bold body-1">Tabla Programación Pagos</span>
					<div class="flex-grow-1 ml-2" style="border-bottom: 1px solid #ccc;"></div>
				</div>
				<div class="d-flex align-center justify-space-between">
					<div class="flex-1"></div>
					<div class="d-flex justify-center align-center flex-1">
						<v-menu
							v-model="colorPickerVisible"
							:close-on-content-click="false"
							offset-y
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									depressed
									color="grey"
									small
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-palette</v-icon>
								</v-btn>
							</template>
							<v-card>
								<div>
									<div class="pa-2">
										<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
										<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
										<div class="d-flex align-center">
											<v-tooltip bottom
														v-for="(colorVar, key) in colorVars"
														:key="key">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="white"
														small
														icon
														v-bind="attrs"
														v-on="on"
														:style="{
															border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
															marginRight: '5px',
															boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
														}"
														@click="openColorPicker(colorVar.value)"
													>
														<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
													</v-btn>
												</template>
												<span>{{colorVar.text}}</span>
											</v-tooltip>
										</div>
									</div>
									<v-color-picker
										v-model="currentColor"
										dot-size="25"
										hide-sliders
										mode="rgba"
										dense
										show-swatches
										swatches-max-height="100"
									/>
								</div>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
								</v-card-actions>
							</v-card>
						</v-menu>
					</div>
					<div class="flex-1 d-flex justify-end align-center">
						<div class="mr-1">
							<CompanyTemplatesHandler
								:type="'cost_table_payments'"
								:itemContent="costsPayments"
								color="black"
								@template-content-selected="templateContentSelected"/>
						</div>
						<v-tooltip bottom v-if="costsPayments.length > 0">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="black"
									outlined
									small
									:disabled="totalProjectCostSummary.total_cost_uf <= 0"
									@click="editProjectPlanning"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small>mdi-chart-gantt</v-icon>
									<p class="mb-0 ml-2">Editar Programación</p>
								</v-btn>
							</template>
							<span>Editar Programación del Proyecto</span>
						</v-tooltip>
					</div>
				</div>
			</div>
			<v-simple-table class="custom-table-cost payments caption responsive-table">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }">
							<td style="vertical-align: middle;flex-grow: 1; min-width: 270px;" rowspan="2" class="text-left">
								<div class="d-flex align-center justify-space-between">
									<p class="mb-0 font-weight-bold">Programación Pagos</p>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 110px;max-width: 110px;width: 110px;" class="text-center" rowspan="2">
								<div class="d-flex align-center justify-end">
									<p class="mb-0 font-weight-bold caption">Es Subcontrato</p>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 140px;max-width: 140px;width: 140px;" class="text-right" rowspan="2">
								<div class="d-flex align-center justify-end">
									<p class="mb-0 font-weight-bold caption">Contrato</p>
								</div>
							</td>
							<td v-if="costsPayments.length === 0" colspan="2" rowspan="2" class="text-center">
								<p class="mb-0 font-weight-bold caption">Configuración Estados de Pago</p>
							</td>
							<td v-for="(costsPayment, indexPayment) in costsPayments"
								style="vertical-align: middle;min-width: 200px;max-width: 200px;width: 200px;"
								:key="'projectPlannedStageHeaders_'+costsPayment.id"
								colspan="2">
								<p class="text-center mb-0" style="font-size: 10px;">Estado Pago {{indexPayment + 1}}</p>
								<p class="text-center mb-0 caption font-weight-bold">{{costsPayment.stage?.name}}{{ costsPayment.stage?.description ? ': '+costsPayment.stage?.description:''}}</p>
							</td>
							<td style="vertical-align: middle;width: 120px;" class="text-right" rowspan="2">
								<div class="d-flex align-center justify-end">
									<p class="mb-0 font-weight-bold">Totales</p>
								</div>
							</td>
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }">
							<template v-for="(costsPayment) in costsPayments">
								<td
									:key="'projectPlannedStageHeadersA_'+costsPayment.id"
									style="width: 60px;min-width: 60px;"
									class="px-1">
									<p class="text-center mb-0" style="font-size: 10px;">%</p>
								</td>
								<td
									:key="'projectPlannedStageHeadersB_'+costsPayment.id"
									style="width:90px;min-width: 90px;"
									class="px-1">
									<p class="text-center mb-0" style="font-size: 10px;">Monto Cuota</p>
								</td>
							</template>
						</tr>
					</thead>
					<!-- Main Project -->
					<tbody>
						<template v-for="projectTableId in itemsByProjectTable.order">
							<!-- Main Projects for this project table -->
							<tr v-for="(main_project, index) in itemsByProjectTable.grouped[projectTableId].mainProjects" :key="'main_project_' + main_project.project_table.id + '_' + index" :class="{ 'disabled-stage-row': getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0 }">
							<td style="vertical-align: middle;" class="text-left pr-2">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="main_project.project_table?.contract?.parent_contract ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ main_project.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="main_project.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 caption font-weight-bold text--disabled" v-m2-span>{{ getMainProjectTitle(main_project) }}</p>
										<p class="mb-0 font-weight-bold" v-html="getMainProjectDescription(main_project)"></p>
										<p class="font-weight-bold caption mb-0">{{ main_project.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(main_project.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;">
								<div class="d-flex align-center justify-center">
									<v-checkbox
										:input-value="main_project.project_table.subcontract"
										dense
										hide-details
										color="#959595"
										@change="handleSubcontractChange({...main_project.project_table, item_type: 'cost_table'}, $event)"
										class="caption my-0 py-0"
										:class="{ 'blocked-content-cost-table': isSubcontractSectionClosed(main_project, 'cost_table') }"></v-checkbox>
									<!-- <p class="mb-0 text--disabled" style="font-size: 10px;">Subcontrato</p> -->
								</div>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">{{main_project.project_table.tax?.name}} ({{ main_project.project_table.tax?.value }}%)</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									<div v-if="getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0" class="mt-1">
										<div class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>Configura los montos en tabla de costo</span>
										</div>
									</div>
								</div>
							</td>
							<td v-if="showProjectPaymentsInitialConfigIn === 'main_project' && index === 0" colspan="2" :rowspan="initialPaymentsConfigRowspan" class="text-center">
								<p class="mb-0 font-weight-bold">No se ha configurado una programación para el proyecto y sus estados de pago</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											depressed
											:color="paymentConfigTableColor"
											dark
											class="mt-2"
											:disabled="totalProjectCostSummary.total_cost_uf <= 0"
											@click="editProjectPlanning"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon :color="calcFontColor(paymentConfigTableColor)" small>mdi-chart-gantt</v-icon>
											<p class="mb-0 caption ml-2" :style="{color: calcFontColor(paymentConfigTableColor)}">Crear Programación del Proyecto</p>
										</v-btn>
									</template>
									<span>Configura la programación del proyecto y sus estados de pago</span>
								</v-tooltip>
							</td>
							<template v-for="(costsPayment, indexP) in costsPayments">
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(main_project) }"
									v-if="main_project.project_table?.contract.addendum_index"
									:key="'mpA_'+costsPayment.id"
									class="px-1"
									colspan="2"
									style="vertical-align: top;">
									<p class="mb-0 caption font-weight-bold">Subtotal para EP {{ indexP + 1 }}</p>
									<div class="d-flex align-start justify-space-between px-1 py-2" style="border: 1px solid grey; border-radius: 5px;"
										v-if="
											getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id) &&
											getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id)?.amount">
										<div class="px-2">
											{{ getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id)?.amount || '' }}%
										</div>
										<div>
											<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).amount/100 | toThousandFilter(2)}} UF</p>
											<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).amount/100 | toThousandFilter}} CLP</p>
										</div>
									</div>

									<div class="px-1 py-2" style="color: #FF120B; border: 1px solid #FF120B; border-radius: 5px;" v-else>
										<p class="mb-0 caption text-center" style="line-height: 1.2;">Configura las cuotas para este estado de pago en la siguiente sección</p>
									</div>

									<v-divider class="my-1"></v-divider>
									<p class="mb-1 caption font-weight-bold">Pago en Cuotas</p>
									<div class="mb-2">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="grey"
													x-small
													block
													class="py-3"
													@click="startConfigSubpayments(costsPayment, 'cost_table', main_project.project_table.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-chart-gantt</v-icon>
													<p class="ml-2 mb-0 caption">Agregar Cuota</p>
												</v-btn>
											</template>
											<span>Agrega cuota al estado de pago</span>
										</v-tooltip>
									</div>
									<div v-if="getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id) && getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).subpayments && getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).subpayments.length > 0">
										<div v-for="(subpayment, index) in getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).subpayments" :key="'sub_' + subpayment.id">
											<v-divider class="my-2"></v-divider>
											<div>
												<div class="d-flex align-center">
													<v-text-field
														:value="subpayment.title"
														class="custom-height-search custom-height-calendar custom-type-text"
														hide-details
														dense
														outlined
														placeholder="Nombre"
														maxlength="80"
														@input="val => subpayment.title = val"
													></v-text-field>
													<v-btn
														icon
														x-small
														color="error"
														class="ml-1 flex-shrink-0"
														@click="removeSubpayment(costsPayment, index, 'cost_table', main_project.project_table.id)">
														<v-icon small>mdi-delete-outline</v-icon>
													</v-btn>
												</div>
												<div class="d-flex justify-space-between align-center mt-2">
													<div class="pl-2 d-flex align-center">
														<v-text-field
															:ref="'sub_cost_table_' + main_project.project_table.id + '_' + index"
															:value="subpayment.amount"
															class="custom-height-search custom-height-calendar custom-type-number"
															style="width: 40px"
															type="number"
															hide-details
															dense
															outlined
															@input="val => updateSubpaymentValue(costsPayment, index, val, 'cost_table', main_project.project_table.id)"
														></v-text-field>
														<p class="mb-0 ml-1 caption">%</p>
													</div>
													<div class="text-right">
														<p class="mb-0 caption font-weight-bold">{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed * subpayment.amount / 100 | toThousandFilter(2)}} UF</p>
														<p class="mb-0 caption font-weight-bold">${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed * subpayment.amount / 100 | toThousandFilter}} CLP</p>
													</div>
												</div>
											</div>
										</div>
										<div v-if="getAllPaymentPercentValues('cost_table', main_project.project_table.id) < 100" class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>La suma de los pagos debe ser 100%</span>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(main_project) }"
									v-if="!main_project.project_table?.contract.addendum_index"
									:key="'mpA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<div style="position: relative;width: 100%;">
										<v-text-field
											:ref="'cost_table_'+costsPayment.id + '_' + main_project.project_table.id"
											:value="getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id)?.amount"
											class="custom-height-search custom-height-calendar custom-type-number mb-0"
											type="number"
											hide-details
											dense
											outlined
											@input="val => preUpdateValue(costsPayment, 'cost_table', val, main_project.project_table.id)"
										></v-text-field>
										<div v-if="indexP === 0 && getAllPaymentPercentValues('cost_table', main_project.project_table.id) < 100" style="position: absolute; bottom: -24px; right: 0; left: 0; text-align: center; line-height: 1.2; pointer-events: none;">
											<p class="mb-0" style="color: #FF120B; font-size: 8px; font-weight: bold;">⚠ Los % deben sumar 100%</p>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(main_project) }"
									v-if="!main_project.project_table?.contract.addendum_index"
									:key="'mpB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id)">
										<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'cost_table', main_project.project_table.id).amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<div class="text-right">
									<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues('cost_table', main_project.project_table.id)}}%</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getAllPaymentPercentValues('cost_table', main_project.project_table.id)/100 | toThousandFilter(2)}} UF</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getAllPaymentPercentValues('cost_table', main_project.project_table.id)/100 | toThousandFilter}} CLP</p>
								</div>
							</td>
						</tr>
						<!-- Cost Stages -->
						<tr v-for="stage in itemsByProjectTable.grouped[projectTableId].stages" :key="'stages_'+stage.id" :class="{ 'disabled-stage-row': !stage.active || getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0 }">
							<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left pr-2">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-start mb-1" style="gap: 10px;">
											<v-chip
												:color="stage.project_table?.contract?.parent_contract ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center"
												:class="{ 'disabled-stage-single-item': !stage.active }">
												<p class="mb-0">{{ stage.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="stage.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="px-2"
												:class="{ 'disabled-stage-single-item': !stage.active }">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<div class="d-flex justify-center align-center" style="gap: 10px;">
											<p class="mb-0 caption" :class="stage.active ? 'grey--text' : ''">Incluir en Notas</p>
											<v-btn
												class="px-0"
												icon
												depressed
												small
												:disabled="stage.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												:color="stage.active ? 'success' : '#959595'"
												@click="changeStageStatus(stage.id)"
											>
												<v-icon large>{{stage.active ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline'}}</v-icon>
											</v-btn>
											<p class="mb-0 caption" :class="stage.active ? '' : 'grey--text'">Incluir en Tabla de Costo</p>
										</div>
										<div :class="{ 'disabled-stage-single-item': !stage.active }">
											<p class="mb-0 font-weight-bold">{{stage.stage?.name}}</p>
											<p class="font-weight-bold caption mb-0">{{ stage.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(stage.project_table?.contract) }}</p>
										</div>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;">
								<div class="d-flex align-center justify-center">
									<v-checkbox
										:input-value="stage.subcontract"
										dense
										hide-details
										color="#959595"
										@change="handleSubcontractChange({...stage, item_type: 'stage'}, $event)"
										class="caption my-0 py-0"
										:class="{ 'blocked-content-cost-table': isSubcontractSectionClosed(stage, 'stage') }"></v-checkbox>
								</div>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">{{stage.project_table.tax?.name}} ({{ stage.project_table.tax?.value }}%)</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									<div v-if="stage.active && getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0" class="mt-1">
										<div class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>Configura los montos en tabla de costo</span>
										</div>
									</div>
								</div>
							</td>
							<td v-if="showProjectPaymentsInitialConfigIn === 'stage'" colspan="2" :rowspan="initialPaymentsConfigRowspan" class="text-center">
								<p class="mb-0 font-weight-bold">No se ha configurado una programación para el proyecto y sus estados de pago</p>
											<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													:color="paymentConfigTableColor"
													dark
													class="mt-2"
													:disabled="totalProjectCostSummary.total_cost_uf <= 0"
													@click="editProjectPlanning"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon :color="calcFontColor(paymentConfigTableColor)" small>mdi-chart-gantt</v-icon>
													<p class="mb-0 caption ml-2" :style="{color: calcFontColor(paymentConfigTableColor)}">Crear Programación del Proyecto</p>
												</v-btn>
											</template>
											<span>Configura la programación del proyecto y sus estados de pago</span>
										</v-tooltip>
								<p></p>
							</td>
							<template
								v-for="(costsPayment, indexP) in costsPayments">
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(stage) }"
									v-if="stage.project_table?.contract.addendum_index"
									:key="'stageA_'+costsPayment.id"
									class="px-1"
									colspan="2"
									style="vertical-align: top;">
									<p class="mb-0 caption font-weight-bold">Subtotal para EP {{ indexP + 1 }}</p>
									<div class="d-flex align-start justify-space-between px-1 py-2" style="border: 1px solid grey; border-radius: 5px;"
										v-if="
											getPaymentValue(costsPayment, 'stage', stage.id) &&
											getPaymentValue(costsPayment, 'stage', stage.id)?.amount">
										<div class="px-2">
											{{ getPaymentValue(costsPayment, 'stage', stage.id)?.amount || '' }}%
										</div>
										<div>
											<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'stage', stage.id).amount/100 | toThousandFilter(2)}} UF</p>
											<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'stage', stage.id).amount/100 | toThousandFilter}} CLP</p>
										</div>
									</div>

									<div class="px-1 py-2" style="color: #FF120B; border: 1px solid #FF120B; border-radius: 5px;" v-else>
										<p class="mb-0 caption text-center" style="line-height: 1.2;">Configura las cuotas para este estado de pago en la siguiente sección</p>
									</div>
									<v-divider class="my-1"></v-divider>
									<p class="mb-1 caption font-weight-bold">Pago en Cuotas</p>
									<div class="mb-2">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="grey"
													x-small
													block
													class="py-3"
													@click="startConfigSubpayments(costsPayment, 'stage', stage.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-chart-gantt</v-icon>
													<p class="ml-2 mb-0 caption">Agregar Cuota</p>
												</v-btn>
											</template>
											<span>Agrega cuota al estado de pago</span>
										</v-tooltip>
									</div>
									<div v-if="getPaymentValue(costsPayment, 'stage', stage.id) && getPaymentValue(costsPayment, 'stage', stage.id).subpayments && getPaymentValue(costsPayment, 'stage', stage.id).subpayments.length > 0">
										<div v-for="(subpayment, index) in getPaymentValue(costsPayment, 'stage', stage.id).subpayments" :key="'sub_' + subpayment.id">
											<v-divider class="my-2"></v-divider>
											<div>
												<div class="d-flex align-center">
													<v-text-field
														:value="subpayment.title"
														class="custom-height-search custom-height-calendar custom-type-text"
														hide-details
														dense
														outlined
														placeholder="Nombre"
														maxlength="80"
														@input="val => subpayment.title = val"
													></v-text-field>
													<v-btn
														icon
														x-small
														color="error"
														class="ml-1 flex-shrink-0"
														@click="removeSubpayment(costsPayment, index, 'stage', stage.id)">
														<v-icon small>mdi-delete-outline</v-icon>
													</v-btn>
												</div>
												<div class="d-flex justify-space-between align-center mt-2">
													<div class="pl-2 d-flex align-center">
														<v-text-field
															:ref="'sub_stage_' + stage.id + '_' + index"
															:value="subpayment.amount"
															class="custom-height-search custom-height-calendar custom-type-number"
															style="width: 40px"
															type="number"
															hide-details
															dense
															outlined
															@input="val => updateSubpaymentValue(costsPayment, index, val, 'stage', stage.id)"
														></v-text-field>
														<p class="mb-0 ml-1 caption">%</p>
													</div>
													<div class="text-right">
														<p class="mb-0 caption font-weight-bold">{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed * subpayment.amount / 100 | toThousandFilter(2)}} UF</p>
														<p class="mb-0 caption font-weight-bold">${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed * subpayment.amount / 100 | toThousandFilter}} CLP</p>
													</div>
												</div>
											</div>
										</div>
										<div v-if="getAllPaymentPercentValues('stage', stage.id) < 100" class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>La suma de los pagos debe ser 100%</span>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(stage) }"
									v-if="!stage.project_table?.contract.addendum_index"
									:key="'stageA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<div style="position: relative;width: 100%;">
										<v-text-field
											:ref="'stage_'+costsPayment.id + '_' + stage.id"
											:value="getPaymentValue(costsPayment, 'stage', stage.id)?.amount"
											class="custom-height-search custom-height-calendar custom-type-number mb-0"
											type="number"
											hide-details
											dense
											outlined
											@input="val => preUpdateValue(costsPayment, 'stage', val, stage.id)"
										></v-text-field>
										<div v-if="stage.active && indexP === 0 && getAllPaymentPercentValues('stage', stage.id) < 100" style="position: absolute; bottom: -24px; right: 0; left: 0; text-align: center; line-height: 1.2; pointer-events: none;">
											<p class="mb-0" style="color: #FF120B; font-size: 8px; font-weight: bold;">⚠ Los % deben sumar 100%</p>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(stage) }"
									v-if="!stage.project_table?.contract.addendum_index"
									:key="'stageB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'stage', stage.id)">
										<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'stage', stage.id).amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'stage', stage.id).amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<div class="text-right">
									<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues('stage', stage.id)}}%</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getAllPaymentPercentValues('stage', stage.id)/100 | toThousandFilter(2)}} UF</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getAllPaymentPercentValues('stage', stage.id)/100 | toThousandFilter}} CLP</p>
								</div>
							</td>
						</tr>
						<!-- Reception Project -->
						<tr v-if="itemsByProjectTable.grouped[projectTableId].reception" :key="'reception_' + projectTableId" :class="{ 'disabled-stage-row': itemsByProjectTable.grouped[projectTableId].reception && getSubtotalForProjectTable(projectTableId).total_cost_uf_taxed == 0 }">
							<td style="vertical-align: middle;min-width: 240px;" :width="colWidths[0]" class="text-left pr-2">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="itemsByProjectTable.grouped[projectTableId].reception.project_table?.contract?.parent_contract ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ itemsByProjectTable.grouped[projectTableId].reception.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="itemsByProjectTable.grouped[projectTableId].reception.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 font-weight-bold">Recepción</p>
										<p class="font-weight-bold caption mb-0">{{ itemsByProjectTable.grouped[projectTableId].reception.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(itemsByProjectTable.grouped[projectTableId].reception.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;">
								<div class="d-flex align-center justify-center">
									<v-checkbox
										:input-value="itemsByProjectTable.grouped[projectTableId].reception.subcontract"
										dense
										hide-details
										color="#959595"
										@change="handleSubcontractChange({...itemsByProjectTable.grouped[projectTableId].reception, item_type: 'reception'}, $event)"
										class="caption my-0 py-0"
										:class="{ 'blocked-content-cost-table': isSubcontractSectionClosed(itemsByProjectTable.grouped[projectTableId].reception, 'reception') }"></v-checkbox>
								</div>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">{{itemsByProjectTable.grouped[projectTableId].reception.project_table.tax?.name}} ({{ itemsByProjectTable.grouped[projectTableId].reception.project_table.tax?.value }}%)</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									<div v-if="getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0" class="mt-1">
										<div class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>Configura los montos en tabla de costo</span>
										</div>
									</div>
								</div>
							</td>
							<td v-if="showProjectPaymentsInitialConfigIn === 'reception'" colspan="2" :rowspan="initialPaymentsConfigRowspan" class="text-center">
								<p class="mb-0 font-weight-bold">No se ha configurado una programación para el proyecto y sus estados de pago</p>
											<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													:color="paymentConfigTableColor"
													dark
													class="mt-2"
													:disabled="totalProjectCostSummary.total_cost_uf <= 0"
													@click="editProjectPlanning"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon :color="calcFontColor(paymentConfigTableColor)" small>mdi-chart-gantt</v-icon>
													<p class="mb-0 caption ml-2" :style="{color: calcFontColor(paymentConfigTableColor)}">Crear Programación del Proyecto</p>
												</v-btn>
											</template>
											<span>Configura la programación del proyecto y sus estados de pago</span>
										</v-tooltip>
								<p></p>
							</td>
							<template
								v-for="(costsPayment, indexP) in costsPayments">
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(summaryInfo.reception) }"
									v-if="summaryInfo.reception.project_table?.contract.addendum_index"
									:key="'recA_'+costsPayment.id"
									class="px-1"
									colspan="2"
									style="vertical-align: top;">
									<p class="mb-0 caption font-weight-bold">Subtotal para EP {{ indexP + 1 }}</p>
									<div class="d-flex align-start justify-space-between px-1 py-2" style="border: 1px solid grey; border-radius: 5px;"
										v-if="
											getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id) &&
											getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)?.amount">
										<div class="px-2">
											{{ getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)?.amount || '' }}%
										</div>
										<div>
											<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).amount/100 | toThousandFilter(2)}} UF</p>
											<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).amount/100 | toThousandFilter}} CLP</p>
										</div>
									</div>

									<div class="px-1 py-2" style="color: #FF120B; border: 1px solid #FF120B; border-radius: 5px;" v-else>
										<p class="mb-0 caption text-center" style="line-height: 1.2;">Configura las cuotas para este estado de pago en la siguiente sección</p>
									</div>
									<v-divider class="my-1"></v-divider>
									<p class="mb-1 caption font-weight-bold">Pago en Cuotas</p>
									<div class="mb-2">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="grey"
													x-small
													block
													class="py-3"
													@click="startConfigSubpayments(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-chart-gantt</v-icon>
													<p class="ml-2 mb-0 caption">Agregar Cuota</p>
												</v-btn>
											</template>
											<span>Agrega cuota al estado de pago</span>
										</v-tooltip>
									</div>
									<div v-if="getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id) && getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).subpayments && getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).subpayments.length > 0">
										<div v-for="(subpayment, index) in getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).subpayments" :key="'sub_' + subpayment.id">
											<v-divider class="my-2"></v-divider>
											<div>
												<div class="d-flex align-center">
													<v-text-field
														:value="subpayment.title"
														class="custom-height-search custom-height-calendar custom-type-text"
														hide-details
														dense
														outlined
														placeholder="Nombre"
														maxlength="80"
														@input="val => subpayment.title = val"
													></v-text-field>
													<v-btn
														icon
														x-small
														color="error"
														class="ml-1 flex-shrink-0"
														@click="removeSubpayment(costsPayment, index, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)">
														<v-icon small>mdi-delete-outline</v-icon>
													</v-btn>
												</div>
												<div class="d-flex justify-space-between align-center mt-2">
													<div class="pl-2 d-flex align-center">
														<v-text-field
															:ref="'sub_reception_' + itemsByProjectTable.grouped[projectTableId].reception.id + '_' + index"
															:value="subpayment.amount"
															class="custom-height-search custom-height-calendar custom-type-number"
															style="width: 40px"
															type="number"
															hide-details
															dense
															outlined
															@input="val => updateSubpaymentValue(costsPayment, index, val, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)"
														></v-text-field>
														<p class="mb-0 ml-1 caption">%</p>
													</div>
													<div class="text-right">
														<p class="mb-0 caption font-weight-bold">{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed * subpayment.amount / 100 | toThousandFilter(2)}} UF</p>
														<p class="mb-0 caption font-weight-bold">${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp_taxed * subpayment.amount / 100 | toThousandFilter}} CLP</p>
													</div>
												</div>
											</div>
										</div>
										<div v-if="getAllPaymentPercentValues('reception', itemsByProjectTable.grouped[projectTableId].reception.id) < 100" class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>La suma de los pagos debe ser 100%</span>
										</div>
									</div>
								</td>
								<td 
									:class="{ 'blocked-content-cost-table': isSectionClosed(summaryInfo.reception) }"
									v-if="!summaryInfo.reception.project_table?.contract.addendum_index"
									:key="'recA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<div style="position: relative;width: 100%;">
										<v-text-field
											:ref="'reception_'+costsPayment.id + '_' + itemsByProjectTable.grouped[projectTableId].reception.id"
											:value="getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)?.amount"
											class="custom-height-search custom-height-calendar custom-type-number mb-0"
											type="number"
											hide-details
											dense
											outlined
											@input="val => preUpdateValue(costsPayment, 'reception', val, itemsByProjectTable.grouped[projectTableId].reception.id)"
										></v-text-field>
										<div v-if="indexP === 0 && getAllPaymentPercentValues('reception', itemsByProjectTable.grouped[projectTableId].reception.id) < 100" style="position: absolute; bottom: -24px; right: 0; left: 0; text-align: center; line-height: 1.2; pointer-events: none;">
											<p class="mb-0" style="color: #FF120B; font-size: 8px; font-weight: bold;">⚠ Los % deben sumar 100%</p>
										</div>
									</div>
								</td>
								<td 
									:class="{ 'blocked-content-cost-table': isSectionClosed(summaryInfo.reception) }"
									v-if="!summaryInfo.reception.project_table?.contract.addendum_index"
									:key="'recB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id)">
										<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'reception', itemsByProjectTable.grouped[projectTableId].reception.id).amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<div class="text-right">
									<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues('reception', itemsByProjectTable.grouped[projectTableId].reception.id)}}%</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getAllPaymentPercentValues('reception', itemsByProjectTable.grouped[projectTableId].reception.id)/100 | toThousandFilter(2)}} UF</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(itemsByProjectTable.grouped[projectTableId].reception, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.tax, itemsByProjectTable.grouped[projectTableId].reception?.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getAllPaymentPercentValues('reception', itemsByProjectTable.grouped[projectTableId].reception.id)/100 | toThousandFilter}} CLP</p>
								</div>
							</td>
						</tr>
						<!-- Cost Specialties -->
						<tr v-for="specialty in itemsByProjectTable.grouped[projectTableId].specialties" :key="'specialties_'+specialty.id" :class="{ 'disabled-stage-row': getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0 }">
							<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left pr-2">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="specialty.project_table?.contract?.parent_contract ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ specialty.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="specialty.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 font-weight-bold">{{specialty.specialty?.name}}</p>
										<p class="font-weight-bold caption mb-0">{{ specialty.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(specialty.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;">
								<div class="d-flex align-center justify-center">
									<v-checkbox
										:input-value="specialty.subcontract"
										dense
										hide-details
										color="#959595"
										@change="handleSubcontractChange({...specialty, item_type: 'specialty'}, $event)"
										class="caption my-0 py-0"
										:class="{ 'blocked-content-cost-table': isSubcontractSectionClosed(specialty, 'specialty') }"></v-checkbox>
								</div>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">{{specialty.project_table.tax?.name}} ({{ specialty.project_table.tax?.value }}%)</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1"></v-divider>
									<p class="mb-0 font-weight-bold text--disabled" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
									<div v-if="getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed == 0" class="mt-1">
										<div class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>Configura los montos en tabla de costo</span>
										</div>
									</div>
								</div>
							</td>
							<td v-if="showProjectPaymentsInitialConfigIn === 'specialty'" colspan="2" :rowspan="initialPaymentsConfigRowspan" class="text-center">
								<p class="mb-0 font-weight-bold">No se ha configurado una programación para el proyecto y sus estados de pago</p>
											<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													:color="paymentConfigTableColor"
													dark
													class="mt-2"
													:disabled="totalProjectCostSummary.total_cost_uf <= 0"
													@click="editProjectPlanning"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon :color="calcFontColor(paymentConfigTableColor)" small>mdi-chart-gantt</v-icon>
													<p class="mb-0 caption ml-2" :style="{color: calcFontColor(paymentConfigTableColor)}">Crear Programación del Proyecto</p>
												</v-btn>
											</template>
											<span>Configura la programación del proyecto y sus estados de pago</span>
										</v-tooltip>
								<p></p>
							</td>
							<template
								v-for="(costsPayment, indexP) in costsPayments">
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(specialty) }"
									v-if="specialty.project_table?.contract.addendum_index"
									:key="'specialtyA_'+costsPayment.id"
									class="px-1"
									colspan="2"
									style="vertical-align: top;">
									<p class="mb-0 caption font-weight-bold">Subtotal para EP {{ indexP + 1 }}</p>
									<div class="d-flex align-start justify-space-between px-1 py-2" style="border: 1px solid grey; border-radius: 5px;"
										v-if="
											getPaymentValue(costsPayment, 'specialty', specialty.id) &&
											getPaymentValue(costsPayment, 'specialty', specialty.id)?.amount">
										<div class="px-2">
											{{ getPaymentValue(costsPayment, 'specialty', specialty.id)?.amount || '' }}%
										</div>
										<div>
											<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'specialty', specialty.id).amount/100 | toThousandFilter(2)}} UF</p>
											<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'specialty', specialty.id).amount/100 | toThousandFilter}} CLP</p>
										</div>
									</div>

									<div class="px-1 py-2" style="color: #FF120B; border: 1px solid #FF120B; border-radius: 5px;" v-else>
										<p class="mb-0 caption text-center" style="line-height: 1.2;">Configura las cuotas para este estado de pago en la siguiente sección</p>
									</div>
									<v-divider class="my-1"></v-divider>
									<p class="mb-1 caption font-weight-bold">Pago en Cuotas</p>
									<div class="mb-2">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="grey"
													x-small
													block
													class="py-3"
													@click="startConfigSubpayments(costsPayment, 'specialty', specialty.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-chart-gantt</v-icon>
													<p class="ml-2 mb-0 caption">Agregar Cuota</p>
												</v-btn>
											</template>
											<span>Agrega cuota al estado de pago</span>
										</v-tooltip>
									</div>
									<div v-if="getPaymentValue(costsPayment, 'specialty', specialty.id) && getPaymentValue(costsPayment, 'specialty', specialty.id).subpayments && getPaymentValue(costsPayment, 'specialty', specialty.id).subpayments.length > 0">
										<div v-for="(subpayment, index) in getPaymentValue(costsPayment, 'specialty', specialty.id).subpayments" :key="'sub_' + subpayment.id">
											<v-divider class="my-2"></v-divider>
											<div>
												<div class="d-flex align-center">
													<v-text-field
														:value="subpayment.title"
														class="custom-height-search custom-height-calendar custom-type-text"
														hide-details
														dense
														outlined
														placeholder="Nombre"
														maxlength="80"
														@input="val => subpayment.title = val"
													></v-text-field>
													<v-btn
														icon
														x-small
														color="error"
														class="ml-1 flex-shrink-0"
														@click="removeSubpayment(costsPayment, index, 'specialty', specialty.id)">
														<v-icon small>mdi-delete-outline</v-icon>
													</v-btn>
												</div>
												<div class="d-flex justify-space-between align-center mt-2">
													<div class="pl-2 d-flex align-center">
														<v-text-field
															:ref="'sub_specialty_' + specialty.id + '_' + index"
															:value="subpayment.amount"
															class="custom-height-search custom-height-calendar custom-type-number"
															style="width: 40px"
															type="number"
															hide-details
															dense
															outlined
															@input="val => updateSubpaymentValue(costsPayment, index, val, 'specialty', specialty.id)"
														></v-text-field>
														<p class="mb-0 ml-1 caption">%</p>
													</div>
													<div class="text-right">
														<p class="mb-0 caption font-weight-bold">{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed * subpayment.amount / 100 | toThousandFilter(2)}} UF</p>
														<p class="mb-0 caption font-weight-bold">${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed * subpayment.amount / 100 | toThousandFilter}} CLP</p>
													</div>
												</div>
											</div>
										</div>
										<div v-if="getAllPaymentPercentValues('specialty', specialty.id) < 100" class="payments-warning-box" role="alert" aria-live="assertive">
											<v-icon small color="error">mdi-alert-circle</v-icon>
											<span>La suma de los pagos debe ser 100%</span>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(specialty) }"
									v-if="!specialty.project_table?.contract.addendum_index"
									:key="'specialtyA_'+costsPayment.id"
									class="px-1"
									style="vertical-align: middle;">
									<div style="position: relative;width: 100%;">
										<v-text-field
											:ref="'specialty_'+costsPayment.id + '_' + specialty.id"
											:value="getPaymentValue(costsPayment, 'specialty', specialty.id)?.amount"
											class="custom-height-search custom-height-calendar custom-type-number mb-0"
											type="number"
											hide-details
											dense
											outlined
											@input="val => preUpdateValue(costsPayment, 'specialty', val, specialty.id)"
										></v-text-field>
										<div v-if="indexP === 0 && getAllPaymentPercentValues('specialty', specialty.id) < 100" style="position: absolute; bottom: -24px; right: 0; left: 0; text-align: center; line-height: 1.2; pointer-events: none;">
											<p class="mb-0" style="color: #FF120B; font-size: 8px; font-weight: bold;">⚠ Los % deben sumar 100%</p>
										</div>
									</div>
								</td>
								<td
									:class="{ 'blocked-content-cost-table': isSectionClosed(specialty) }"
									v-if="!specialty.project_table?.contract.addendum_index"
									:key="'specialtyB_'+costsPayment.id"
									style="vertical-align: middle;"
									class="px-1">
									<div v-if="getPaymentValue(costsPayment, 'specialty', specialty.id)">
										<p class="text-right mb-0 caption font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getPaymentValue(costsPayment, 'specialty', specialty.id).amount/100 | toThousandFilter(2)}} UF</p>
										<p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getPaymentValue(costsPayment, 'specialty', specialty.id).amount/100 | toThousandFilter}} CLP</p>
									</div>
									<div v-else>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
										<p class="text-right mb-0 caption font-weight-bold" >--</p>
									</div>
								</td>
							</template>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<div class="text-right">
									<p class="mb-0 font-weight-bold body-1">{{getAllPaymentPercentValues('specialty', specialty.id)}}%</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed * getAllPaymentPercentValues('specialty', specialty.id)/100 | toThousandFilter(2)}} UF</p>
									<p  class="mb-0 font-weight-bold body-1">{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed * getAllPaymentPercentValues('specialty', specialty.id)/100 | toThousandFilter}} CLP</p>
								</div>
							</td>
						</tr>
						<!-- Subtotal for Project Table -->
						<tr class="header-rows-custom" :key="'subtotal_' + projectTableId" :style="{ backgroundColor: '#757575', color: 'white' }">
							<td style="vertical-align: middle;" colspan="2" class="text-left py-2">
								<p class="mb-0 font-weight-bold caption" style="font-size: 10px;opacity: 0.7;">Subtotal</p>
								<p class="font-weight-bold caption mb-0">{{ itemsByProjectTable.grouped[projectTableId].project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(itemsByProjectTable.grouped[projectTableId].project_table?.contract) }}</p>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 font-weight-bold" >{{getSubtotalForProjectTable(projectTableId).total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{getSubtotalForProjectTable(projectTableId).total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1 grey"></v-divider>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">{{itemsByProjectTable.grouped[projectTableId].project_table?.tax?.name}} ({{ itemsByProjectTable.grouped[projectTableId].project_table?.tax?.value }}%)</p>
									<p class="text-right mb-0 font-weight-bold" >{{getSubtotalForProjectTable(projectTableId).tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{getSubtotalForProjectTable(projectTableId).tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1 grey"></v-divider>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 font-weight-bold" >{{getSubtotalForProjectTable(projectTableId).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{getSubtotalForProjectTable(projectTableId).total_cost_clp_taxed | toThousandFilter}} CLP</p>
								</div>
							</td>
							<td v-if="costsPayments.length === 0" colspan="2" class="text-center">
								<p class="mb-0 font-weight-bold body-1"></p>
							</td>
							<td 
								v-for="costsPayment in costsPayments"
								:key="'subtotal_B_'+projectTableId+'_'+costsPayment.id"
								colspan="2"
								style="vertical-align: middle;"
								class="py-2">
								<p class="text-right mb-0 font-weight-bold" >{{getTotalSinglePaymentTotalsWithTaxForProjectTable(costsPayment, projectTableId).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getTotalSinglePaymentTotalsWithTaxForProjectTable(costsPayment, projectTableId).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<p class="text-right mb-0 font-weight-bold" >{{getTotalAllPaymentsTotalsWithTaxForProjectTable(costsPayments, projectTableId).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getTotalAllPaymentsTotalsWithTaxForProjectTable(costsPayments, projectTableId).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</template>
					<!-- Totals -->
						<tr class="header-rows-custom" :style="{ backgroundColor: colors['footerPaymentConfigTableColor'], color: calcFontColor(colors['footerPaymentConfigTableColor']) }">
							<td style="vertical-align: middle;" colspan="2" class="text-left py-2">
								<p class="mb-0 font-weight-bold body-1">Total</p>
							</td>
							<td style="vertical-align: middle;" class="text-right">
								<div>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">Neto</p>
									<p class="text-right mb-0 font-weight-bold" >{{totalProjectCostSummary.total_cost_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{totalProjectCostSummary.total_cost_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1 grey"></v-divider>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">Impuestos</p>
									<p class="text-right mb-0 font-weight-bold" >{{totalProjectCostSummary.tax_value_uf | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{totalProjectCostSummary.tax_value_clp | toThousandFilter}} CLP</p>
									<v-divider class="my-1 grey"></v-divider>
									<p class="mb-0 font-weight-bold" style="font-size: 10px;">Total</p>
									<p class="text-right mb-0 font-weight-bold" >{{totalProjectCostSummary.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
									<p class="text-right mb-0 font-weight-bold" >${{totalProjectCostSummary.total_cost_clp_taxed | toThousandFilter}} CLP</p>
								</div>
							</td>
							<td v-if="costsPayments.length === 0" colspan="2" class="text-center">
								<p class="mb-0 font-weight-bold body-1"></p>
							</td>
							<td 
								v-for="costsPayment in costsPayments"
								:key="'totalB_'+costsPayment.id"
								colspan="2"
								style="vertical-align: middle;"
								class="py-2">
								<p class="text-right mb-0 font-weight-bold body-1" >{{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{getTotalSinglePaymentTotalsWithTax(costsPayment).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<td :style="{ backgroundColor: paymentConfigTableColor, color: calcFontColor(paymentConfigTableColor) }" class="text-left pr-2">
								<p class="text-right mb-0 font-weight-bold body-1" >{{getTotalAllPaymentsTotalsWithTax(costsPayments).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{validatedTotal | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
		<AcceptCancelModal
			:closeModal="closeModalAcceptRejectModal"
			:acceptRejectModal="acceptRejectModal"
			:acceptRejectModalData="acceptRejectModalData"
		/>
	</v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import _throttle from 'lodash/throttle'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { getParentItemTotalValueMultiWithTax, getParentItemTotalValueWithTax, getSinglePaymentTotalsWithTax, getAllPaymentsTotalsWithTax } from '@/helpers/tablecostHelpers.js'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'
import { deepDiff } from '@/helpers/tablecostHelpers.js'

import CompanyTemplatesHandler from '@/components/Helpers/Components/CompanyTemplatesHandler'
import {saveProjectCostDetail} from '@/helpers/api/costs'
import {setFromTemplate} from '@/helpers/api/projects'
import AcceptCancelModal from '@/components/Modals/General/AcceptCancelModal'

export default {
	name: 'CostPaymentsTable',
	components: { AcceptCancelModal, CompanyTemplatesHandler },
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		project_tables: {
			type: Array,
			default: () => []
		},
		showHeader: {
			type: Boolean,
			default: true
		},
		saveSelf: {
			type: Boolean,
			default: false
		},
	},
  data() {
    return {
			contractStatuses,
			getParentItemTotalValueMultiWithTax,
			getParentItemTotalValueWithTax,
			getSinglePaymentTotalsWithTax,
			getAllPaymentsTotalsWithTax,
			colWidths: ['15%','11%','11%','11%','11%','11%','11%','11%'],
      colorVars: [
        {'value': 'paymentConfigTableColor', 'text': 'Títulos / Cabecera Tabla Configuración Pagos'},
        {'value': 'footerPaymentConfigTableColor', 'text': 'Totales Tabla Configuración Pagos'},
      ],
      colorPickerVisible: false,
      activeColorKey: 'paymentConfigTableColor',
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			acceptRejectModal: false,
			acceptRejectModalData: null,
			costs_table_check: null,
			savingCostsTableInternal: false,
			pendingCostsTableInternal: null,
			firstDelayTimerInternal: null,
			forceUpdateAfterSave: false,
			accumulatedGetCostUpdated: false,
			paymentInputDebounceTimers: {}
    };
  },
	computed: {
		validatedTotal() {
			const mathTotalClp = Math.round(parseFloat(this.totalProjectCostSummary.total_cost_clp) || 0)
			const mathTotalTaxClp = Math.round(parseFloat(this.totalProjectCostSummary.tax_value_clp) || 0)
			const total = mathTotalClp + mathTotalTaxClp
			return total
		},
		userResponsible(){
			return this.$store.state.user?.userInfo?.id == this.project?.responsible_id
		},
		initialPaymentsConfigRowspan(){
			return this.summaryInfo.mainProjects.length + this.summaryInfo.projects.length + this.summaryInfo.stages.length + this.summaryInfo.specialties.length + (this.summaryInfo.reception ? 1 : 0)
		},
		showProjectPaymentsInitialConfigIn(){
			if(this.costsPayments.length > 0){
				return null;
			}
			if(this.summaryInfo.mainProjects.length){
				return 'main_project';
			}
			else if(this.summaryInfo.projects.length){
				return 'project';
			}
			else if(this.summaryInfo.stages.length){
				return 'stage';
			}
			else if(this.summaryInfo.specialties.length){
				return 'specialty';
			}
			else if(this.summaryInfo.reception){
				return 'reception';
			}
			return null;
		},
		costTableBlocked(){
			return this.projectContractClosed || !this.userResponsible
		},
		projectContractClosed(){
			return this.costsTable?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
		},
		summaryInfo(){
			let summary = {
				reception: null,
				surfaces: [],
				projects: [],
				stages: [],
				specialties: [],
				tax: this.costsTable.tax,
				mainProjects: (this.costsTable.reception || (Array.isArray(this.costsTable.surfaces?.items) && this.costsTable.surfaces.items.length > 0)) ? [{ 
					...{
						reception: this.costsTable.reception,
						surfaces: this.costsTable.surfaces
					},
					project_table: this.costsTable
				}] : []
			};
			
			// Agregar elementos del costsTable principal
			if (this.costsTable.reception) {
				summary.reception = { ...this.costsTable.reception, project_table: this.costsTable };
			}
			if (Array.isArray(this.costsTable.surfaces?.items)) {
				summary.surfaces.push(...this.costsTable.surfaces.items.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.projects)) {
				summary.projects.push(...this.costsTable.projects.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.stages)) {
				summary.stages.push(...this.costsTable.stages.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.specialties)) {
				summary.specialties.push(...this.costsTable.specialties.map(item => ({ ...item, project_table: this.costsTable })));
			}
			
			// Agregar elementos de las tablas adicionales
			this.project_tables.forEach(project_table => {
				if (project_table.reception) {
					summary.reception = { ...project_table.reception, project_table };
				}
				if (Array.isArray(project_table.surfaces?.items)) {
					summary.surfaces.push(...project_table.surfaces.items.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.projects)) {
					summary.projects.push(...project_table.projects.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.stages)) {
					summary.stages.push(...project_table.stages.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.specialties)) {
					summary.specialties.push(...project_table.specialties.map(item => ({ ...item, project_table })));
				}
				if (project_table.reception || (Array.isArray(project_table.surfaces?.items) && project_table.surfaces.items.length > 0)) {
					summary.mainProjects.push({ 
						...{
							reception: project_table.reception,
							surfaces: project_table.surfaces
						},
						project_table: project_table
					});
				}
			});
			return summary;
		},
		projectTypeSubtitle() {
			const parentName = this.project?.info?.project_type?.parent?.name || '';
			const categoryName = this.project?.info?.project_type?.category?.name || '';

			if (parentName && categoryName) {
					return `${categoryName} | ${parentName}`;
			}
			return parentName || categoryName || '';
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		colors(){
			return this.$store.state.costbreakdown.costTableColorMap
		},
		paymentConfigTableColor() {
			return this.$store.state.costbreakdown.costTableColorMap.paymentConfigTableColor;
		},
		costsPayments(){
			return Array.isArray(this.costsTable.payments) ? this.costsTable.payments.filter(p => p) : [];
		},
		projectPlannedStages(){
			const stagesNeedingPayment = (this.project.planning?.planning_categories || [])
																		.flatMap(category => category.stages || [])
																		.filter(stage => stage.needs_payment)
			return stagesNeedingPayment
		},
		projectLineAssociations(){
			if(this.project.associations?.associations){
				const project_associations = this.project.associations
				return project_associations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
		totalProjectCostSummary() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			// Sumar mainProjects
			this.summaryInfo.mainProjects.forEach(mainProject => {
				
				const values = getParentItemTotalValueMultiWithTax([mainProject.project_table, mainProject.surfaces], mainProject.project_table?.tax, mainProject.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar stages
			this.summaryInfo.stages.filter(st => st.active).forEach(stage => {
				const values = getParentItemTotalValueWithTax(stage, stage?.project_table?.tax, stage?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar specialties
			this.summaryInfo.specialties.forEach(specialty => {
				const values = getParentItemTotalValueWithTax(specialty, specialty?.project_table?.tax, specialty?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar reception si existe
			if (this.summaryInfo.reception) {
				const values = getParentItemTotalValueWithTax(this.summaryInfo.reception, this.summaryInfo.reception?.project_table?.tax, this.summaryInfo.reception?.project_table?.uf_value?.uf_value);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			}

			return total;
		},
		totalMainArqProject(){
			const values = getParentItemTotalValueMultiWithTax([this.costsTable, this.costsTable.surfaces], this.costsTable.tax)
			return values;
		},
		receptionTotalCostSummary() {
			const values = getParentItemTotalValueWithTax(this.summaryInfo.reception, this.summaryInfo.reception?.project_table?.tax, this.summaryInfo.reception?.project_table?.uf_value?.uf_value)
			return values;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		dayUfValue(){
			return this.$store.state.general.dayUfValue
		},
		ufValue(){
			return this.selectedUfValue || 40000
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		companyCostSpecialties(){
			return this.$store.state.costbreakdown.companiesCostCategories
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costProjects(){
			return this.$store.state.costbreakdown.companiesBaseProjects
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		allCostTables() {
			const tables = new Set();
			tables.add(this.costsTable);
			this.summaryInfo.mainProjects.forEach(mp => tables.add(mp.project_table));
			this.summaryInfo.projects.forEach(p => tables.add(p.project_table));
			this.summaryInfo.stages.filter(st => st.active).forEach(s => tables.add(s.project_table));
			this.summaryInfo.specialties.forEach(sp => tables.add(sp.project_table));
			if (this.summaryInfo.reception) tables.add(this.summaryInfo.reception.project_table);
			return Array.from(tables);
		},
		itemsByProjectTable() {
			const grouped = {};
			const order = [];

			// Agrupar mainProjects
			this.summaryInfo.mainProjects.forEach(item => {
				const ptId = item.project_table.id;
				if (!grouped[ptId]) {
					grouped[ptId] = { mainProjects: [], stages: [], reception: null, specialties: [], project_table: item.project_table };
					order.push(ptId);
				}
				grouped[ptId].mainProjects.push(item);
			});

			// Agrupar stages
			this.summaryInfo.stages.forEach(item => {
				const ptId = item.project_table.id;
				if (!grouped[ptId]) {
					grouped[ptId] = { mainProjects: [], stages: [], reception: null, specialties: [], project_table: item.project_table };
					order.push(ptId);
				}
				grouped[ptId].stages.push(item);
			});

			// Agrupar reception
			if (this.summaryInfo.reception) {
				const ptId = this.summaryInfo.reception.project_table.id;
				if (!grouped[ptId]) {
					grouped[ptId] = { mainProjects: [], stages: [], reception: null, specialties: [], project_table: this.summaryInfo.reception.project_table };
					order.push(ptId);
				}
				grouped[ptId].reception = this.summaryInfo.reception;
			}

			// Agrupar specialties
			this.summaryInfo.specialties.forEach(item => {
				const ptId = item.project_table.id;
				if (!grouped[ptId]) {
					grouped[ptId] = { mainProjects: [], stages: [], reception: null, specialties: [], project_table: item.project_table };
					order.push(ptId);
				}
				grouped[ptId].specialties.push(item);
			});
			// console.log('[DEBUG] grouped', grouped, 'order', order)
			return { grouped, order };
		},
	},
	watch: {
		costsTable: {
			deep: true,
			handler(newValue){
				if(!this.costs_table_check){
					this.costs_table_check = JSON.parse(JSON.stringify(newValue))
					return
				}
				const diff = deepDiff(this.costs_table_check, newValue)
				// console.log('[DEBUG] diff', diff)
				if(diff && diff.length > 0){
					const get_updated_value = this.shouldGetCostsAfterSave(diff)
					// console.log('[DEBUG] get_updated_value', get_updated_value)
					this.startSaveCostTable(get_updated_value)
				}
				this.costs_table_check = JSON.parse(JSON.stringify(newValue))
			}
		},
	},
	mounted(){
		this.checkIfCostsItems()
		this.costsPayments.forEach(cp => {
			if (!Array.isArray(cp.payments)) {
				cp.payments = [];
			}
			this.$set(cp, 'total_amount', this.getTotalAmount(cp));
		});
	},
	beforeDestroy() {
		Object.values(this.paymentInputDebounceTimers).forEach(timerId => {
			clearTimeout(timerId)
		})
		this.paymentInputDebounceTimers = {}
	},
  methods: {
		shouldGetCostsAfterSave(changes) {
			const subcontractPatterns = [
				/^subcontract$/,
				/^reception\.subcontract$/,
				/^specialties\[\d+\]\.subcontract$/,
				/^stages\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.reception\.subcontract$/,
				/^project_tables\[\d+\]\.specialties\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.stages\[\d+\]\.subcontract$/,
			]

			return changes.some(d => {
				const isNewObject =
					typeof d.newValue === 'object' &&
					d.newValue !== null &&
					d.newValue.id === null

				const isAddedCase = d.type === 'added' && isNewObject

				const isSubcontractCase =
						d.oldValue === false &&
						d.newValue === true &&
						subcontractPatterns.some(regex => regex.test(d.path))

				const isReceptionCase =
					isNewObject &&
					(
						d.path === 'reception' ||
						/^project_tables\[\d+\]\.reception$/.test(d.path)
					)

				return isAddedCase || isSubcontractCase || isReceptionCase
			})
		},
		startSaveCostTable(get_cost_table_updated = false) {

			const run = async (arg) => {
				this.savingCostsTableInternal = true
				this.accumulatedGetCostUpdated = false

				try {
					await this.sendSaveEvent(arg)
				} finally {
					this.savingCostsTableInternal = false

					if (this.pendingCostsTableInternal !== null) {
						const nextArg = this.pendingCostsTableInternal
						this.pendingCostsTableInternal = null
						run(nextArg)
					}
				}
			}
			if (!this.savingCostsTableInternal && !this.firstDelayTimerInternal) {

				this.accumulatedGetCostUpdated = get_cost_table_updated

				this.firstDelayTimerInternal = setTimeout(() => {
					this.firstDelayTimerInternal = null
					run(this.accumulatedGetCostUpdated)
				}, 300)

				return
			}
			if (this.firstDelayTimerInternal) {
				this.accumulatedGetCostUpdated =
					this.accumulatedGetCostUpdated || get_cost_table_updated

				clearTimeout(this.firstDelayTimerInternal)

				this.firstDelayTimerInternal = setTimeout(() => {
					this.firstDelayTimerInternal = null
					run(this.accumulatedGetCostUpdated)
				}, 300)

				return
			}
			if (this.pendingCostsTableInternal !== null) {
				this.pendingCostsTableInternal = this.pendingCostsTableInternal || get_cost_table_updated
			} else {
				this.pendingCostsTableInternal = get_cost_table_updated
			}
		},
		async templateContentSelected(template){
			const data = {
				project_id: this.project.id,
				stages: template,
				template_name: 'Plantilla Programación'
			}
			await setFromTemplate(data)
			eventBus.$emit('reloadInformation')
		},
		getMainProjectDescription(mainProject){
			return mainProject?.project_table?.project_cost_info?.title || ''
		},
		getMainProjectTitle(mainProject){
      const parentName = mainProject?.project_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = mainProject?.project_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = mainProject?.project_table?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		changeStageStatus(stageId){
			let foundIndex = this.costsTable.stages.findIndex(st => st.id === stageId)
			if(foundIndex === -1){
				this.costsTable.project_tables.forEach(project_table => {
					foundIndex = project_table.stages.findIndex(st => st.id === stageId)
				})
			}
			if(foundIndex !== -1){
				this.$set(this.costsTable.stages[foundIndex], 'active', !this.costsTable.stages[foundIndex].active)
			}
		},
		handleSubcontractChange(item, newValue) {
			if (item.item_type === 'stage') {
				const stageIndex = this.costsTable.stages.findIndex(s => s.id === item.id)
				if (stageIndex !== -1) {
					this.$set(this.costsTable.stages[stageIndex], 'subcontract', newValue)
				} else {
					// Si no está en stages principal, buscar en project_tables
					if (Array.isArray(this.costsTable.project_tables)) {
						for (let projectTable of this.costsTable.project_tables) {
							if (Array.isArray(projectTable.stages)) {
								const ptStageIndex = projectTable.stages.findIndex(s => s.id === item.id)
								if (ptStageIndex !== -1) {
									this.$set(projectTable.stages[ptStageIndex], 'subcontract', newValue)
									break
								}
							}
						}
					}
				}
			} else if (item.item_type === 'specialty') {
				const specialtyIndex = this.costsTable.specialties.findIndex(sp => sp.id === item.id)
				if (specialtyIndex !== -1) {
					this.$set(this.costsTable.specialties[specialtyIndex], 'subcontract', newValue)
				} else {
					// Si no está en specialties principal, buscar en project_tables
					if (Array.isArray(this.costsTable.project_tables)) {
						for (let projectTable of this.costsTable.project_tables) {
							if (Array.isArray(projectTable.specialties)) {
								const ptSpecialtyIndex = projectTable.specialties.findIndex(sp => sp.id === item.id)
								if (ptSpecialtyIndex !== -1) {
									this.$set(projectTable.specialties[ptSpecialtyIndex], 'subcontract', newValue)
									break
								}
							}
						}
					}
				}
			} else if (item.item_type === 'cost_table') {
				if(this.costsTable.id === item.id){
					this.$set(this.costsTable, 'subcontract', newValue)
				}
				else{
					const secondaryMainProjectTable = this.costsTable.project_tables.findIndex(pt => pt.id === item.id)
					if(secondaryMainProjectTable !== -1){
						this.$set(this.costsTable.project_tables[secondaryMainProjectTable], 'subcontract', newValue)
					}
				}
			} else if (item.item_type === 'reception') {
				if(this.costsTable.reception?.id === item.id){
					this.$set(this.costsTable.reception, 'subcontract', newValue)
				}
				else if (Array.isArray(this.costsTable.project_tables)) {
					for (let projectTable of this.costsTable.project_tables) {
						if (projectTable.reception && projectTable.reception.id === item.id) {
							this.$set(projectTable.reception, 'subcontract', newValue)
						}
					}
				}
			} else if (item.item_type === 'secondary_project') {
				const secondaryIndex = this.costsTable.secondary_projects.findIndex(sp => sp.id === item.id)
				if (secondaryIndex !== -1) {
					this.$set(this.costsTable.secondary_projects[secondaryIndex], 'subcontract', newValue)
				}
			}
		},
		isSectionClosed(section){
			return section.project_table?.contract && 
						(section.project_table.contract.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES)
		},
		isSubcontractSectionClosed(section, item_type = 'cost_table'){
			if(item_type == 'cost_table'){
				const subcontract = section.project_table?.subcontracts_info?.cost_table
				return subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
			}
			else if(item_type == 'reception'){
				const subcontract = section.project_table?.subcontracts_info?.reception
				return subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
			}
			else if(item_type == 'stage'){
				const subcontract = section.project_table?.subcontracts_info?.stages?.find(s => s.id == section.id)
				return subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
			}
			else if(item_type == 'specialty'){
				const subcontract = section.project_table?.subcontracts_info?.specialties?.find(s => s.id == section.id)
				return subcontract?.subcontract?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
			}
			return false
		},
		startConfigSubpayments(costsPayment, paymentProjectType = 'cost_table', typeItemId = null){
			// Validar que la sección no tenga ya 100%
			const currentPercentForType = this.getAllPaymentPercentValues(paymentProjectType, typeItemId);
			
			if (currentPercentForType >= 100) {
				this.debounceSetMessage({
					message: 'Esta sección ya tiene asignado el 100% de las cuotas. No se pueden agregar más cuotas.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				});
				return;
			}

			const index = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			if (!Array.isArray(costsPayment.payments)) {
				costsPayment.payments = [];
			}
			let payment = costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);
			if (!payment) {
				payment = {
					item_type: paymentProjectType,
					amount: 0,
					subpayments: []
				};
				if (typeItemId !== null) {
					payment.type_item_id = typeItemId;
				}
				costsPayment.payments.push(payment);
			}
			if (!Array.isArray(payment.subpayments)) {
				payment.subpayments = [];
			}
			const newSubpaymentIndex = payment.subpayments.length;
			const epIndex = index + 1;
			const newSubpayment = {
				amount: 0,
				id: 'sub_' + Date.now(),
				title: `Cuota ${newSubpaymentIndex + 1} - EP ${epIndex}`
			};
			payment.subpayments.push(newSubpayment);
			payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
			this.$set(costsPayment, 'total_amount', this.getTotalAmount(costsPayment));
			this.$set(this.costsTable.payments, index, costsPayment);
		},
		updateSubpaymentValue(costsPayment, index, val, paymentProjectType = 'cost_table', typeItemId = null) {
			const costsPaymentIndex = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			if (!Array.isArray(costsPayment.payments)) {
				costsPayment.payments = [];
			}
			let payment = costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);
			if (payment && payment.subpayments && payment.subpayments[index]) {
				let newVal = parseFloat(val) || 0;
				
				// Calcular el total actual de cuotas (excluyendo la actual)
				const currentSubtotal = payment.subpayments.reduce((sum, sub, i) => {
					return i !== index ? sum + (parseFloat(sub.amount) || 0) : sum;
				}, 0);
				
				// Obtener el porcentaje ya asignado de otros estados de pago para este tipo
				const otherPaymentsPercent = this.costsPayments.reduce((total, cp) => {
					if (cp === costsPayment) return total;
					if (!Array.isArray(cp.payments)) return total;
					
					const matchingPayments = cp.payments.filter(p =>
						p.item_type === paymentProjectType &&
						(typeItemId === null || p.type_item_id === typeItemId)
					);
					return total + matchingPayments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
				}, 0);
				
				// Calcular el máximo disponible
				const maxAllowed = Math.max(0, 100 - currentSubtotal - otherPaymentsPercent);
				
				// Si supera el máximo disponible, ajustarlo automáticamente
				if (newVal > maxAllowed) {
					this.debounceSetMessage({
						message: `El total de cuotas no puede superar el 100%. Se ha ajustado al máximo disponible de ${maxAllowed}%.`,
						title: 'Validación',
						type: 'warning',
						icon: 'mdi-alert-circle-outline',
						color: '#FF9800',
					});
					newVal = maxAllowed;
					// Forzar en nextTick después del re-render de Vuetify para que no pise internalValue
					const clampedVal = newVal;
					const refKey = 'sub_' + paymentProjectType + '_' + typeItemId + '_' + index;
					this.$nextTick(() => {
						const comp = this.$refs[refKey];
						if (comp) {
							const c = Array.isArray(comp) ? comp[0] : comp;
							c.internalValue = clampedVal;
						}
					});
				}
				
				this.$set(payment.subpayments[index], 'amount', newVal);
				payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
				this.$set(costsPayment, 'total_amount', this.getTotalAmount(costsPayment));
				this.$set(this.costsTable.payments, costsPaymentIndex, costsPayment);
			}
			// No llamar sendSaveEvent aquí
		},
		removeSubpayment(costsPayment, index, paymentProjectType = 'cost_table', typeItemId = null) {
			const costsPaymentIndex = this.costsTable.payments.findIndex(cp => cp.id === costsPayment.id);
			if (!Array.isArray(costsPayment.payments)) {
				costsPayment.payments = [];
			}
			let payment = costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);
			if (payment && payment.subpayments && payment.subpayments[index]) {
				payment.subpayments.splice(index, 1);
				payment.amount = payment.subpayments.reduce((sum, sub) => sum + (parseFloat(sub.amount) || 0), 0);
				this.$set(costsPayment, 'total_amount', this.getTotalAmount(costsPayment));
				this.$set(this.costsTable.payments, costsPaymentIndex, costsPayment);
			}
			// No llamar sendSaveEvent aquí
		},
		startSaveEvent: _debounce(function(force_update = false) { this.sendSaveEvent(force_update) }, 800),
		sendSaveEvent(force_update = false){
			if(this.saveSelf){
				this.saveCostsTable()
			}
			console.log('force_update', force_update)
			this.$emit('update:costsPayments', force_update);
		},
		async saveCostsTable(get_cost_table_updated = true){
			// if(this.costs_table.id !== 112361){
			// 	console.log('[DEBUG] saveCostsTable called with costs_table:', this.costs_table)
			// 	return
			// }
			const data = {
				...this.costsTable,
				project_cost_id: this.costsTable.id,
				parent_project_cost_id: this.costsTable.id,
				get_cost_table_updated
			}
			
			const save_costs = await saveProjectCostDetail(data)
			if(save_costs.code == 200){
				const messageData = {
					message: 'Tabla de Costo guardada correctamente',
					title: 'Tabla de Costo Guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.startSetMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		closeModalAcceptRejectModal(data){
			if(data){
				// this.editProjectPlanning()
				this.$router.push({ hash: '#general' })
			}
			this.acceptRejectModalData = null
			this.acceptRejectModal = false
		},
		checkIfCostsPayments(){
			if(!this.costsTable.payments || !this.costsTable.payments.length){
				this.acceptRejectModalData = {
					title: 'Proyecto sin Programación',
					content_a: 'El proyecto no tiene programación asignada. Por favor antes de continuar, asigne la programación del proyecto.',
					content_b: '¿Desea continuar con el proceso de configuración de pagos de la programación del proyecto?',
				}
				this.acceptRejectModal = true
			}
		},
		checkIfCostsItems(){
			if(this.totalProjectCostSummary.total_cost_uf <= 0){
				this.acceptRejectModalData = {
					title: 'Proyecto sin Costos',
					content_a: 'El proyecto no tiene costos asignados. ',
					content_b: 'Por favor antes de continuar, asigne los costos del proyecto en la Tabla de Costos.',
				}
				this.acceptRejectModal = true
			}
		},
		getAllPaymentPercentValues(paymentProjectType, typeItemId = null) {
			if (!Array.isArray(this.costsPayments)) return 0;

			return this.costsPayments.reduce((total, costsPayment) => {
				let sum = 0;
				if (Array.isArray(costsPayment.payments)) {
					const matchingPayments = costsPayment.payments.filter(p =>
						p.item_type === paymentProjectType &&
						(typeItemId === null || p.type_item_id === typeItemId)
					);
					sum += matchingPayments.reduce((subtotal, p) => {
						const amount = parseFloat(p.amount);
						return subtotal + (isNaN(amount) ? 0 : amount);
					}, 0);
				}
				return total + sum;
			}, 0);
		},
		getPaymentValue(costsPayment, paymentProjectType, typeItemId = null) {
			if (!costsPayment || !Array.isArray(costsPayment.payments)) return null;
			return costsPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			) || null;
		},
		normalizePaymentAmount(value) {
			const parsedValue = parseFloat(value)
			if (isNaN(parsedValue)) return 0
			return Math.max(0, parsedValue)
		},
		getPaymentInputKey(costPayment, paymentProjectType, typeItemId = null) {
			const safeTypeItemId = typeItemId === null || typeItemId === undefined ? 'global' : typeItemId
			return paymentProjectType + '_' + costPayment.id + '_' + safeTypeItemId
		},
		syncPaymentInputDisplay(costPayment, paymentProjectType, typeItemId = null, value = 0) {
			const refKey = this.getPaymentInputKey(costPayment, paymentProjectType, typeItemId)
			this.$nextTick(() => {
				const ref = this.$refs[refKey]
				if (!ref) return
				const component = Array.isArray(ref) ? ref[0] : ref
				if (!component) return

				component.internalValue = value
				if (Object.prototype.hasOwnProperty.call(component, 'lazyValue')) {
					component.lazyValue = value
				}
			})
		},
		calculateMaxAllowedPaymentPercent(paymentProjectType, costPayment, typeItemId = null) {
			if (!Array.isArray(this.costsPayments)) return 100

			const costPaymentId = costPayment?.id
			let currentTotal = 0

			this.costsPayments.forEach(cp => {
				if (!Array.isArray(cp.payments)) return

				cp.payments.forEach(p => {
					const matchesType = p.item_type === paymentProjectType
					const matchesItemId = typeItemId === null || p.type_item_id === typeItemId

					if (matchesType && matchesItemId && cp.id !== costPaymentId) {
						const amount = parseFloat(p.amount)
						currentTotal += isNaN(amount) ? 0 : amount
					}
				})
			})

			return Math.max(0, 100 - currentTotal)
		},
		clampPaymentAmount(paymentProjectType, costPayment, newValue, typeItemId = null) {
			const normalizedValue = this.normalizePaymentAmount(newValue)
			const maxAllowed = this.calculateMaxAllowedPaymentPercent(paymentProjectType, costPayment, typeItemId)
			const clampedValue = Math.min(normalizedValue, maxAllowed)

			return {
				value: clampedValue,
				wasClamped: normalizedValue !== clampedValue
			}
		},
		queuePaymentValueUpdate(costPayment, paymentProjectType, newValue, typeItemId = null) {
			const key = this.getPaymentInputKey(costPayment, paymentProjectType, typeItemId)

			if (this.paymentInputDebounceTimers[key]) {
				clearTimeout(this.paymentInputDebounceTimers[key])
			}

			this.paymentInputDebounceTimers[key] = setTimeout(() => {
				delete this.paymentInputDebounceTimers[key]
				this.updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId)
			}, 300)
		},
		preUpdateValue(costPayment, paymentProjectType, newValue, typeItemId = null){
			const { value, wasClamped } = this.clampPaymentAmount(paymentProjectType, costPayment, newValue, typeItemId)
			if (wasClamped) {
				this.debounceSetMessage({
					message: 'El porcentaje de este elemento supera el 100%. Se ha ajustado al máximo disponible.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
			}
			this.queuePaymentValueUpdate(costPayment, paymentProjectType, value, typeItemId)
		},
		updatePaymentValue(costPayment, paymentProjectType, newValue, typeItemId = null, options = {}) {
			const skipClamp = !!options.skipClamp
			let finalValue = this.normalizePaymentAmount(newValue)

			if (!skipClamp) {
				const { value, wasClamped } = this.clampPaymentAmount(paymentProjectType, costPayment, finalValue, typeItemId)
				finalValue = value

				if (wasClamped) {
					this.debounceSetMessage({
						message: 'El porcentaje de este elemento supera el 100%. Se ha ajustado al máximo disponible.',
						title: 'Validación',
						type: 'error',
						icon: 'mdi-alert-circle-outline',
						color: '#FF120B',
					})
					this.syncPaymentInputDisplay(costPayment, paymentProjectType, typeItemId, finalValue)
				}
			}

			if (!Array.isArray(costPayment.payments)) {
				costPayment.payments = [];
			}
			let payment = costPayment.payments.find(p =>
				p.item_type === paymentProjectType &&
				(typeItemId === null || p.type_item_id === typeItemId)
			);

			if (payment) {
				const currentAmount = this.normalizePaymentAmount(payment.amount)
				if (currentAmount === finalValue) {
					this.syncPaymentInputDisplay(costPayment, paymentProjectType, typeItemId, finalValue)
					return
				}
				payment.amount = finalValue;
			} else {
				const newPayment = {
					item_type: paymentProjectType,
					amount: finalValue
				};
				if (typeItemId !== null) {
					newPayment.type_item_id = typeItemId;
				}
				costPayment.payments.push(newPayment);
			}
			this.$set(costPayment, 'total_amount', this.getTotalAmount(costPayment));
			const updatedCostsPayments = this.costsPayments?.map(cp =>
				cp.id === costPayment.id ? costPayment : cp
			);
			this.$emit('update:costsPayments', updatedCostsPayments);
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
		editProjectPlanning(){
			this.$store.commit('projects/setProjectPlanningConfigModal', {project: this.project, status: true})
		},
		getTotalSinglePaymentTotalsWithTax(costsPayment) {
			let total = { total_cost_uf_taxed: 0, total_cost_clp_taxed: 0 };
			this.allCostTables.forEach(costTable => {
				const filteredStages = costTable.stages.filter(stage => stage.active);
				const filteredCostTable = { ...costTable, stages: filteredStages };
				const val = getSinglePaymentTotalsWithTax(costsPayment, filteredCostTable);
				total.total_cost_uf_taxed += val.total_cost_uf_taxed || 0;
				total.total_cost_clp_taxed += val.total_cost_clp_taxed || 0;
			});
			// console.log('Calculating total for single payment:', costsPayment);
			// console.log('Total single payment totals with tax:', total);
			return total;
		},
		getTotalAllPaymentsTotalsWithTax(costsPayments) {
			let total = { total_cost_uf_taxed: 0, total_cost_clp_taxed: 0 };
			this.allCostTables.forEach(costTable => {
				const filteredStages = costTable.stages.filter(stage => stage.active);
				const filteredCostTable = { ...costTable, stages: filteredStages };
				const val = getAllPaymentsTotalsWithTax(costsPayments, filteredCostTable);
				total.total_cost_uf_taxed += val.total_cost_uf_taxed || 0;
				total.total_cost_clp_taxed += Math.round(val.total_cost_clp_taxed || 0);
			});
			return total;
		},
		getTotalSinglePaymentTotalsWithTaxForProjectTable(costsPayment, projectTableId) {
			let total = { total_cost_uf_taxed: 0, total_cost_clp_taxed: 0 };
			const grouped = this.itemsByProjectTable.grouped[projectTableId];
			if (!grouped || !grouped.project_table) return total;
			
			// Construir un costsTable sintético con solo los items del proyecto_table
			const syntheticCostsTable = {
				id: grouped.project_table.id,
				tax: grouped.project_table.tax,
				uf_value: grouped.project_table.uf_value,
				projects: grouped.mainProjects || [],
				stages: (grouped.stages || []).filter(s => s.active),
				reception: grouped.reception || null,
				specialties: grouped.specialties || [],
				surfaces: grouped.project_table.surfaces || []
			};
			
			const val = getSinglePaymentTotalsWithTax(costsPayment, syntheticCostsTable);
			total.total_cost_uf_taxed = val.total_cost_uf_taxed || 0;
			total.total_cost_clp_taxed = val.total_cost_clp_taxed || 0;
			return total;
		},
		getTotalAllPaymentsTotalsWithTaxForProjectTable(costsPayments, projectTableId) {
			let total = { total_cost_uf_taxed: 0, total_cost_clp_taxed: 0 };
			if (!Array.isArray(costsPayments)) return total;
			
			costsPayments.forEach(costsPayment => {
				const val = this.getTotalSinglePaymentTotalsWithTaxForProjectTable(costsPayment, projectTableId);
				total.total_cost_uf_taxed += val.total_cost_uf_taxed || 0;
				total.total_cost_clp_taxed += Math.round(val.total_cost_clp_taxed || 0);
			});
			return total;
		},
		getProjectCode(contract) {
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		getTotalAmount(costsPayment) {
			let total = 0;
			if (Array.isArray(costsPayment.payments)) {
				total += costsPayment.payments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
			}
			return total;
		},
		getAmountForType(costsPayment, paymentProjectType, typeItemId = null) {
			let sum = 0;
			if (Array.isArray(costsPayment.payments)) {
				const matching = costsPayment.payments.filter(p => p.item_type === paymentProjectType && (typeItemId === null || p.type_item_id === typeItemId));
				sum += matching.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
			}
			return sum;
		},
		getSubtotalForProjectTable(projectTableId) {
			let subtotal = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			const { grouped } = this.itemsByProjectTable;
			const group = grouped[projectTableId];

			if (!group) return subtotal;

			// Sumar mainProjects
			group.mainProjects.forEach(mainProject => {
				const values = getParentItemTotalValueMultiWithTax([mainProject.project_table, mainProject.surfaces], mainProject.project_table?.tax, mainProject.project_table?.uf_value?.uf_value);
				subtotal.total_cost_uf += values.total_cost_uf || 0;
				subtotal.tax_value_uf += values.tax_value_uf || 0;
				subtotal.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				subtotal.total_cost_clp += values.total_cost_clp || 0;
				subtotal.tax_value_clp += values.tax_value_clp || 0;
				subtotal.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar stages
			group.stages.forEach(stage => {
				const values = getParentItemTotalValueWithTax(stage, stage?.project_table?.tax, stage?.project_table?.uf_value?.uf_value);
				subtotal.total_cost_uf += values.total_cost_uf || 0;
				subtotal.tax_value_uf += values.tax_value_uf || 0;
				subtotal.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				subtotal.total_cost_clp += values.total_cost_clp || 0;
				subtotal.tax_value_clp += values.tax_value_clp || 0;
				subtotal.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar specialties
			group.specialties.forEach(specialty => {
				const values = getParentItemTotalValueWithTax(specialty, specialty?.project_table?.tax, specialty?.project_table?.uf_value?.uf_value);
				subtotal.total_cost_uf += values.total_cost_uf || 0;
				subtotal.tax_value_uf += values.tax_value_uf || 0;
				subtotal.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				subtotal.total_cost_clp += values.total_cost_clp || 0;
				subtotal.tax_value_clp += values.tax_value_clp || 0;
				subtotal.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar reception si existe
			if (group.reception) {
				const values = getParentItemTotalValueWithTax(group.reception, group.reception?.project_table?.tax, group.reception?.project_table?.uf_value?.uf_value);
				subtotal.total_cost_uf += values.total_cost_uf || 0;
				subtotal.tax_value_uf += values.tax_value_uf || 0;
				subtotal.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				subtotal.total_cost_clp += values.total_cost_clp || 0;
				subtotal.tax_value_clp += values.tax_value_clp || 0;
				subtotal.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			}

			return subtotal;
		},
		debounceSetMessage: _debounce(function(messageData){ this.setMessage(messageData) }, 200),
		startSetMessage: _throttle(function(messageData) { this.setMessage(messageData) }, 5000),
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  },
};
</script>

<style scoped>
	.responsive-table {
		width: 100% !important;
	}
	.responsive-table >>> table {
		width: 100% !important;
		table-layout: auto !important;
		border-collapse: collapse;
	}
	.responsive-table >>> table td {
		border: 1px solid #ccc;
		padding: 4px 8px !important;
		word-wrap: break-word;
		overflow-wrap: break-word;
	}
	.responsive-table >>> .col-title {
		min-width: 180px;
		flex: 1;
	}
	.responsive-table >>> .col-value {
		min-width: 100px;
		flex: 1;
	}
	.responsive-table >>> .col-action {
		min-width: 100px;
		flex: 0 0 auto;
	}
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom.indigo:hover{
		background: #3f51b5 !important;
	}
	.custom-table-cost table .header-rows-custom.green:hover{
		background: #4CAF50 !important;
	}
	.custom-table-cost table .header-rows-custom.warning:hover{
		background: #fb8c00 !important;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}
</style>
<style>
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
	.cst-payments-config .custom-table-cost table {
		table-layout: auto;
	}
	.cst-payments-config .custom-table-cost table thead tr td:first-child {
		min-width: 350px;
		width: auto;
	}
	.cst-payments-config .custom-table-cost table tbody tr td:first-child {
		min-width: 350px;
		width: auto;
	}
	.cst-payments-config .custom-table-cost table td:nth-child(2),
	.cst-payments-config .custom-table-cost table td:nth-child(3),
	.cst-payments-config .custom-table-cost table td:nth-child(n+4):not(:last-child) {
		width: auto;
	}
	.custom-type-number .v-input__slot{
		padding:0 4px!important;
	}
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type="number"] {
		-moz-appearance: textfield;
	}
	.cst-payments-config .custom-table-cost.payments tbody tr:nth-of-type(odd) {
		background-color: rgba(0, 0, 0, .025);
	}
</style>
<style scoped>
.payments-warning-box {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 8px;
	margin-top: 6px;
	background-color: rgba(255, 18, 11, 0.08);
	border: 1px solid #FF120B;
	border-radius: 4px;
	color: #FF120B;
	font-size: 9px;
	font-weight: 700;
	line-height: 1.3;
	text-align: left;
}
	.blocked-content-cost-table {
		pointer-events: none;
		opacity: 0.6;
	}
	/deep/.disabled-stage-row td:not(:first-child) {
		pointer-events: none;
		position: relative;
	}
	/deep/.disabled-stage-row td:not(:first-child)::before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(255, 255, 255, 0.45);
		pointer-events: none;
		z-index: 1;
	}
	/deep/.disabled-stage-row td:not(:first-child) .payments-warning-box {
		position: relative;
		z-index: 2;
	}
	.disabled-stage-single-item {
		pointer-events: none;
		opacity: 0.6;
	}
</style>